import * as React from "react";
import MyPage from "../pages/MyPage";
import { useSelector } from "react-redux";
import { AppState } from "../store";
import { PaymentPlanEnum } from "../generated/UserAPIAgent";

const MyPageContainer = (): JSX.Element => {
    const myUser = useSelector((state: AppState) => state.myData.user);
    const paymentStatus = useSelector(
        (state: AppState) => state.payment.status
    );
    const standardCardPaymentPlan = paymentStatus.cardPaymentPlans.find(
        (plan) => plan.paymentPlanId === PaymentPlanEnum.STANDARD_1M_CARD_9800
    );

    return (
        <MyPage
            user={myUser}
            paymentStatus={paymentStatus}
            standardCardPaymentPlan={standardCardPaymentPlan}
        />
    );
};

export default MyPageContainer;
